'use client';

import { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

import { CompletedTask } from '@/hooks/api/quanta/useQuantaMissionTasks';
import { Button } from '@/components/button';

import Icons from './Icons';
import Drawer from './Drawer';
import TaskHistory from './TaskHistory';

interface MissionsCardProps {
  completedTasks: CompletedTask[];
}

const MissionsCard: React.FC<MissionsCardProps> = ({ completedTasks }: MissionsCardProps) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <div className='flex flex-1 3xl:flex-none flex-col border border-border-primary bg-surface-primary rounded-2xl shadow-missions'>
        <div className='flex flex-col-reverse 3xl:grid 3xl:grid-cols-2 items-center 3xl:items-stretch rounded-t-2xl'>
          <div className='flex flex-col gap-6 w-full p-6 lg:p-8'>
            <div className='flex flex-col gap-1'>
              <p className='text-2xl font-medium text-text-primary'>Missions</p>
              <p className='text-xl text-text-secondary'>Simple tasks that earn big Quanta to launch you to the next level.</p>
            </div>
            <div className='flex flex-col sm:flex-row lg:flex-col xl:flex-row xl:flex-wrap xl:items-center gap-2 sm:gap-4 xl:gap-6'>
              {/* TODO: check accessibility when button is wrapped in a link */}
              <Link href='/quanta/missions'>
                <Button size='large' variant='primary' trailingIcon={<Icons.ArrowRightUp />} className='!w-full'>
                  Go to Missions
                </Button>
              </Link>
              <Button size='large' variant='secondary' trailingIcon={<Icons.TaskHistory />} onClick={openDrawer}>
                Task history
              </Button>
            </div>
          </div>
          <Image src='/assets/quanta/missions/grouped.png' alt='Missions' width={467} height={224} />
        </div>
        <div className='flex lg:flex-1 3xl:flex-none flex-col 3xl:flex-row 3xl:justify-between gap-6 p-6 lg:p-8 border-t border-border-primary rounded-b-2xl'>
          <div className='flex flex-1 3xl:flex-none flex-col gap-1'>
            <p className='text-2xl font-medium text-text-primary'>Side missions</p>
            <p className='text-xl text-text-secondary'>Earn extra Quanta through participation in Discord, NFT communities, and more.</p>
          </div>
          {/* flex-col & flex-row are used as a hack for button width */}
          <div className='flex flex-col sm:flex-row lg:flex-col xl:flex-row xl:flex-wrap'>
            <Link href='/quanta/side-missions'>
              <Button size='large' variant='secondary' trailingIcon={<Icons.ArrowRightUp />} className='!w-full'>
                Go to side missions
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <Drawer isOpen={isDrawerOpen} title='Task history' buttonTitle='Close' close={closeDrawer}>
        <TaskHistory completedTasks={completedTasks} />
      </Drawer>
    </>
  );
};

export default MissionsCard;
